import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

interface IProps {
  count: any;
  onPageChange: Function;
  page: number;
  rowsPerPage: number;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      textAlign: 'center',
    },
  },
}));

function CustomPagination(props: IProps) {
  const classes = useStyles({});
  const { count, page, rowsPerPage } = props;
  const theme = {
    direction: 'lft',
  };

  const handleFirstPageButtonClick = (event: any) => {
    props.onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: any) => {
    props.onPageChange(event, props.page - 1);
  };

  const handleNextButtonClick = (event: any) => {
    props.onPageChange(event, props.page + 1);
  };

  const handleLastPageButtonClick = (event: any) => {
    props.onPageChange(event, Math.max(0, Math.ceil(props.count / props.rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='Primeira Página'>
        {theme.direction === 'rtl' ? <Icon>last_page</Icon> : <Icon>first_page</Icon>}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label='Página anterior'>
        {theme.direction === 'rtl' ? <Icon>keyboard_arrow_right</Icon> : <Icon>keyboard_arrow_left</Icon>}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='Próxima página'>
        {theme.direction === 'rtl' ? <Icon>keyboard_arrow_left</Icon> : <Icon>keyboard_arrow_right</Icon>}
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='Última página'>
        {theme.direction === 'rtl' ? <Icon>first_page</Icon> : <Icon>last_page</Icon>}
      </IconButton>
    </div>
  );
}

export default CustomPagination;
